export const TRANSLATIONS_AR = {
    TITLE:"ALKAHRABA Bot",
    // Left Menu Titles
    FS_LEFT_MENU_DASHBOARD:"لوحة القيادة",
    FS_LEFT_MENU_CONVERSATION_HISTORY:"تاريخ المحادثات",
    FS_LEFT_MENU_SUPPORT:"يدعم",
    // Header Titles
    FS_TOP_USERNAME_DEFAULT:"Username",
    // Footer Titles
    FS_FOOTER_COPYRIGHTS:"الشركة السعودية للكهرباء ©2022",
    // PAGE Article List
    FS_CHART_CONVERSATION:"المحادثات",
    FS_CHART_COMP_ABND_CONVERSATION:"Completed Vs Abandoned Conversations",
    FS_CHART_AVG_MSG_PER_CONVERSATION:"Average messages per conversation",
    FS_CHART_TOTAL_USERS:"Total users",
    FS_CHART_TOTAL_FEEDBACK:"Total Feedback",
    FS_CHART_SERVICE_COUNT:"Service Count",
    FS_BUTTON_LOAD_MORE:"تحميل المزيد",
    FS_BUTTON_CANCEL:"يلغي",
    // PAGE Article Details
    FS_BUTTON_BACK:"عودة",
    // PAGE Dashboard
    FS_PAGE_START_DATE:"Start Date",
    FS_PAGE_END_DATE:"End Date",
    FS_BUTTON_GO:"يذهب",
    FS_PAGE_REPORT_ONE:"Report One",
    FS_PAGE_REPORT_TWO:"Report Two",
    // Date-Range-picker
    FS_DRP_APPLY:"يتقدم",
    FS_DRP_CANCEL:"يلغي",
    FS_DRP_CUSTOM_RANGE:"نطاق مخصص",
    // Login Page
    FS_ADMINPANEL_TITLE:"SEC Dashboard Login",
    FS_LOGIN:"Login",
    FS_ERR_EMAIL_INVALID:"Email is invalid",
    FS_ERR_EMAIL_IS_REQUIRED:"Email is required",
    FS_ERR_PASSWORD_REQUIRED:"Please Enter your password",
    FS_ERR_PASSWORD_VALIDATION_MSG:"Must Contain 8 Characters, with at least one letter and one number",
    FS_INVALID_CREDENTIALS:"Invalid Credentials! Please try again",
};